/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * 변경 가능한 필드만 수정합니다.
 * @summary 내 프로필 수정
 */
export const buyerProfileControllerUpdateMyProfileBody = zod
  .object({
    email: zod.string().optional().describe("새로운 이메일 주소"),
    profileImageUrl: zod
      .string()
      .optional()
      .describe("프로필 이미지의 공개 URL"),
  })
  .strict();

export const buyerProfileControllerUpdateMyProfileResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("사용자 고유 ID (UUID)"),
        userId: zod.string().describe("사용자가 입력한 ID (username)"),
        name: zod.string().describe("사용자 성명"),
        contactEmail: zod.string().optional().describe("연락처 이메일"),
        phone: zod.string().describe("사용자 전화번호"),
        birthDate: zod
          .string()
          .optional()
          .describe("생년월일 (YYYY-MM-DD 형식)"),
        gender: zod.string().optional().describe("성별 (M: 남성, F: 여성)"),
        telecom: zod.string().optional().describe("통신사"),
        isActive: zod.boolean().describe("계정 활성 상태"),
        userType: zod.string().describe("사용자 유형"),
        profileImageUrl: zod.string().optional().describe("프로필 이미지 URL"),
        lastLoginAt: zod
          .string()
          .optional()
          .describe("마지막 로그인 시간 (ISO 8601 형식)"),
        createdAt: zod.string().describe("사용자 생성 날짜 (ISO 8601 형식)"),
        updatedAt: zod
          .string()
          .optional()
          .describe("프로필 수정일 (ISO 8601 형식)"),
        supplierInfo: zod.object({}).optional().describe("공급자 정보"),
        authId: zod.string().describe("Supabase Auth 사용자 ID (UUID)"),
        withdrawalRequestedAt: zod
          .string()
          .optional()
          .describe("탈퇴 신청 일시 (ISO 8601 형식)"),
        niceVerifiedAt: zod
          .string()
          .optional()
          .describe("NICE 인증 완료 시간 (ISO 8601 형식)"),
        niceResponseNo: zod.string().optional().describe("NICE 응답번호"),
        ci: zod.string().optional().describe("CI (연계정보)"),
        di: zod.string().optional().describe("DI (중복가입확인정보)"),
        supplierId: zod.string().optional().describe("C마켓 공급자 ID"),
        kakaoNotificationEnabled: zod
          .boolean()
          .describe("카카오 알림톡 수신 여부"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 프로필 이미지를 업로드하고 자동으로 반영합니다.
 * @summary 프로필 이미지 업로드
 */
export const buyerProfileControllerUploadProfileImageBody = zod
  .object({
    file: zod
      .instanceof(File)
      .describe("프로필 이미지 파일 (JPEG, PNG, GIF, WebP - 최대 5MB)"),
  })
  .strict();

/**
 * 현재 로그인한 사용자의 가장 최근 본인인증 완료 날짜를 조회합니다.
 * @summary 최근 본인인증 날짜 조회
 */
export const buyerProfileControllerGetVerificationDateResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        verifiedAt: zod
          .string()
          .nullish()
          .describe("본인인증 완료 시간 (ISO 8601)"),
        daysAgo: zod.number().nullish().describe("본인인증 이후 경과 일수"),
        isVerified: zod.boolean().describe("본인인증 여부"),
        displayText: zod.string().nullish().describe("인증 상태 메시지"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 주소 목록을 조회합니다. 기본주소(isDefault=true)가 항상 첫번째로 응답됩니다.
 * @summary 내 주소 목록 조회
 */
export const buyerAddressControllerGetMyAddressesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string().describe("주소 ID (UUID)"),
            userId: zod.string().describe("사용자 ID (UUID)"),
            label: zod
              .string()
              .optional()
              .describe("주소 라벨 (회사, 집, 창고 등)"),
            isDefault: zod.boolean().describe("기본 배송지 여부"),
            postalCode: zod.string().describe("우편번호 (5자리 숫자)"),
            province: zod.string().describe("시/도 (광역시 또는 도 단위)"),
            city: zod.string().describe("시/군/구 (기초자치단체)"),
            district: zod.string().optional().describe("읍/면/동 (선택사항)"),
            streetAddress: zod.string().describe("도로명 주소"),
            addressDetail: zod
              .string()
              .optional()
              .describe("상세 주소 (건물명, 동/호 등)"),
            recipientName: zod.string().optional().describe("수령인 이름"),
            recipientPhone: zod
              .string()
              .optional()
              .describe("수령인 연락처 (휴대폰 또는 일반전화)"),
            createdAt: zod
              .string()
              .optional()
              .describe("생성일 (ISO 8601 형식)"),
            updatedAt: zod
              .string()
              .optional()
              .describe("수정일 (ISO 8601 형식)"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * UPSERT 패턴으로 주소를 추가하거나 수정합니다.
 * @summary 주소 생성 또는 수정 (UPSERT)
 */
export const buyerAddressControllerUpsertAddressBodyLabelMax = 50;

export const buyerAddressControllerUpsertAddressBodyPostalCodeMax = 10;

export const buyerAddressControllerUpsertAddressBodyProvinceMax = 50;

export const buyerAddressControllerUpsertAddressBodyCityMax = 50;

export const buyerAddressControllerUpsertAddressBodyDistrictMax = 50;

export const buyerAddressControllerUpsertAddressBodyStreetAddressMax = 200;

export const buyerAddressControllerUpsertAddressBodyAddressDetailMax = 200;

export const buyerAddressControllerUpsertAddressBodyRecipientNameMax = 50;

export const buyerAddressControllerUpsertAddressBodyRecipientPhoneMax = 20;

export const buyerAddressControllerUpsertAddressBody = zod
  .object({
    label: zod
      .string()
      .max(buyerAddressControllerUpsertAddressBodyLabelMax)
      .optional()
      .describe("주소 라벨"),
    isDefault: zod.boolean().describe("기본 주소 설정"),
    postalCode: zod
      .string()
      .max(buyerAddressControllerUpsertAddressBodyPostalCodeMax)
      .describe("우편번호"),
    province: zod
      .string()
      .max(buyerAddressControllerUpsertAddressBodyProvinceMax)
      .describe("시/도"),
    city: zod
      .string()
      .max(buyerAddressControllerUpsertAddressBodyCityMax)
      .describe("시/군/구"),
    district: zod
      .string()
      .max(buyerAddressControllerUpsertAddressBodyDistrictMax)
      .nullish()
      .describe("읍/면/동 (누락 시 null 저장)"),
    streetAddress: zod
      .string()
      .max(buyerAddressControllerUpsertAddressBodyStreetAddressMax)
      .describe("도로명 주소"),
    addressDetail: zod
      .string()
      .max(buyerAddressControllerUpsertAddressBodyAddressDetailMax)
      .optional()
      .describe("상세 주소"),
    recipientName: zod
      .string()
      .max(buyerAddressControllerUpsertAddressBodyRecipientNameMax)
      .describe("수령인 이름"),
    recipientPhone: zod
      .string()
      .max(buyerAddressControllerUpsertAddressBodyRecipientPhoneMax)
      .optional()
      .describe("수령인 연락처"),
    id: zod.string().nullish().describe("주소 ID (선택사항)"),
  })
  .strict();

/**
 * @summary 주소 삭제
 */
export const buyerAddressControllerDeleteAddressParams = zod
  .object({
    addressId: zod.coerce.string().describe("주소 ID"),
  })
  .strict();

/**
 * 현재 비밀번호를 확인한 뒤 새로운 이메일 주소로 6자리 인증 코드를 보냅니다.
 * @summary 이메일 인증 코드 발송
 */
export const userSettingsControllerSendEmailVerificationCodeBodyCurrentPasswordMax = 64;

export const userSettingsControllerSendEmailVerificationCodeBody = zod
  .object({
    email: zod.string().describe("인증받을 이메일 주소"),
    currentPassword: zod
      .string()
      .max(
        userSettingsControllerSendEmailVerificationCodeBodyCurrentPasswordMax,
      )
      .describe("현재 비밀번호 (본인 재확인)"),
  })
  .strict();

export const userSettingsControllerSendEmailVerificationCodeResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        maskedEmail: zod.string().describe("마스킹된 이메일 주소"),
        expiresIn: zod.number().describe("코드 만료 시간 (초)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 사용자가 받은 6자리 인증 코드를 입력하여 이메일 변경을 완료합니다.
 * @summary 이메일 인증 코드 검증
 */
export const userSettingsControllerVerifyEmailCodeBodyCodeMin = 6;
export const userSettingsControllerVerifyEmailCodeBodyCodeMax = 6;

export const userSettingsControllerVerifyEmailCodeBody = zod
  .object({
    email: zod.string().describe("인증 코드를 받은 이메일 주소"),
    code: zod
      .string()
      .min(userSettingsControllerVerifyEmailCodeBodyCodeMin)
      .max(userSettingsControllerVerifyEmailCodeBodyCodeMax)
      .describe("6자리 인증 코드"),
  })
  .strict();

export const userSettingsControllerVerifyEmailCodeResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        email: zod.string().describe("인증된 이메일 주소"),
        isVerified: zod.boolean().describe("이메일 인증 성공 여부"),
        verifiedAt: zod
          .string()
          .optional()
          .describe("이메일 인증 완료 시간 (ISO 8601)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 현재 로그인한 사용자의 알람 수신 설정을 조회합니다.
 * @summary 내 알람 설정 조회
 */
export const userSettingsControllerGetNotificationSettingsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("설정 ID (UUID)"),
        userId: zod.string().describe("사용자 ID (UUID)"),
        systemEnabled: zod.boolean().describe("시스템 알람 수신 여부"),
        projectEnabled: zod.boolean().describe("프로젝트 알람 수신 여부"),
        chatEnabled: zod.boolean().describe("채팅 알람 수신 여부"),
        paymentEnabled: zod.boolean().describe("결제 알람 수신 여부"),
        reviewEnabled: zod.boolean().describe("후기 알람 수신 여부"),
        kakaoTalkEnabled: zod.boolean().describe("카카오 알림톡 수신 여부"),
        createdAt: zod.string().describe("생성일 (ISO 8601 형식)"),
        updatedAt: zod.string().describe("수정일 (ISO 8601 형식)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 현재 로그인한 사용자의 알람 수신 설정을 업데이트합니다.
 * @summary 내 알람 설정 업데이트
 */
export const userSettingsControllerUpdateNotificationSettingsBody = zod
  .object({
    systemEnabled: zod.boolean().optional().describe("시스템 알람 수신 여부"),
    projectEnabled: zod
      .boolean()
      .optional()
      .describe("프로젝트 알람 수신 여부"),
    chatEnabled: zod.boolean().optional().describe("채팅 알람 수신 여부"),
    paymentEnabled: zod.boolean().optional().describe("결제 알람 수신 여부"),
    reviewEnabled: zod.boolean().optional().describe("후기 알람 수신 여부"),
    kakaoTalkEnabled: zod
      .boolean()
      .optional()
      .describe("카카오 알림톡 수신 여부"),
  })
  .strict();

export const userSettingsControllerUpdateNotificationSettingsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("설정 ID (UUID)"),
        userId: zod.string().describe("사용자 ID (UUID)"),
        systemEnabled: zod.boolean().describe("시스템 알람 수신 여부"),
        projectEnabled: zod.boolean().describe("프로젝트 알람 수신 여부"),
        chatEnabled: zod.boolean().describe("채팅 알람 수신 여부"),
        paymentEnabled: zod.boolean().describe("결제 알람 수신 여부"),
        reviewEnabled: zod.boolean().describe("후기 알람 수신 여부"),
        kakaoTalkEnabled: zod.boolean().describe("카카오 알림톡 수신 여부"),
        createdAt: zod.string().describe("생성일 (ISO 8601 형식)"),
        updatedAt: zod.string().describe("수정일 (ISO 8601 형식)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 현재 로그인한 사용자의 마케팅 정보 수신 동의 상태를 조회합니다.
 * @summary 마케팅 정보 수신 동의 상태 조회
 */
export const userSettingsControllerGetMarketingConsentResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        agreed: zod.boolean().describe("마케팅 정보 수신 동의 여부"),
        agreedAt: zod.string().nullish().describe("동의 시점"),
        revokedAt: zod.string().nullish().describe("철회 시점"),
        consentChannel: zod.string().nullish().describe("동의 채널"),
        version: zod.string().nullish().describe("약관 버전"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 현재 로그인한 사용자의 마케팅 정보 수신 동의를 변경합니다.
 * @summary 마케팅 정보 수신 동의 변경
 */
export const userSettingsControllerUpdateMarketingConsentBody = zod
  .object({
    agreed: zod.boolean().describe("마케팅 정보 수신 동의 여부"),
  })
  .strict();

export const userSettingsControllerUpdateMarketingConsentResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        agreed: zod.boolean().describe("마케팅 정보 수신 동의 여부"),
        agreedAt: zod.string().nullish().describe("동의 시점"),
        revokedAt: zod.string().nullish().describe("철회 시점"),
        consentChannel: zod.string().nullish().describe("동의 채널"),
        version: zod.string().nullish().describe("약관 버전"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 공급자가 자동 견적 응답 기능을 켜거나 끌 수 있습니다.
 * @summary 자동 견적 응답 설정 토글 (공급자 전용)
 */
export const userSettingsControllerToggleAutoQuoteBody = zod
  .object({
    enabled: zod.boolean().describe("자동 견적 응답 활성화 여부"),
  })
  .strict();

export const userSettingsControllerToggleAutoQuoteResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("사용자 고유 ID (UUID)"),
        userId: zod.string().describe("사용자가 입력한 ID (username)"),
        name: zod.string().describe("사용자 성명"),
        contactEmail: zod.string().optional().describe("연락처 이메일"),
        phone: zod.string().describe("사용자 전화번호"),
        birthDate: zod
          .string()
          .optional()
          .describe("생년월일 (YYYY-MM-DD 형식)"),
        gender: zod.string().optional().describe("성별 (M: 남성, F: 여성)"),
        telecom: zod.string().optional().describe("통신사"),
        isActive: zod.boolean().describe("계정 활성 상태"),
        userType: zod.string().describe("사용자 유형"),
        profileImageUrl: zod.string().optional().describe("프로필 이미지 URL"),
        lastLoginAt: zod
          .string()
          .optional()
          .describe("마지막 로그인 시간 (ISO 8601 형식)"),
        createdAt: zod.string().describe("사용자 생성 날짜 (ISO 8601 형식)"),
        updatedAt: zod
          .string()
          .optional()
          .describe("프로필 수정일 (ISO 8601 형식)"),
        supplierInfo: zod.object({}).optional().describe("공급자 정보"),
        authId: zod.string().describe("Supabase Auth 사용자 ID (UUID)"),
        withdrawalRequestedAt: zod
          .string()
          .optional()
          .describe("탈퇴 신청 일시 (ISO 8601 형식)"),
        niceVerifiedAt: zod
          .string()
          .optional()
          .describe("NICE 인증 완료 시간 (ISO 8601 형식)"),
        niceResponseNo: zod.string().optional().describe("NICE 응답번호"),
        ci: zod.string().optional().describe("CI (연계정보)"),
        di: zod.string().optional().describe("DI (중복가입확인정보)"),
        supplierId: zod.string().optional().describe("C마켓 공급자 ID"),
        kakaoNotificationEnabled: zod
          .boolean()
          .describe("카카오 알림톡 수신 여부"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 사용자의 비밀번호를 검증하고 계정을 즉시 탈퇴 처리합니다.
 * @summary 회원 탈퇴 (즉시 처리)
 */
export const userSettingsControllerWithdrawBodyPasswordMin = 6;

export const userSettingsControllerWithdrawBody = zod
  .object({
    password: zod
      .string()
      .min(userSettingsControllerWithdrawBodyPasswordMin)
      .describe("Current password for verification"),
    reason: zod.string().describe("Reason for withdrawal"),
    detail: zod
      .string()
      .optional()
      .describe("Detailed reason for withdrawal (optional)"),
  })
  .strict();

/**
 * 공급사 본인의 기업 프로필. 완성도 게이지와 검증 대기 인증서까지 포함한다.
 * @summary 내 기업 프로필 조회
 */
export const supplierProfileControllerGetMyProfileResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        supplierId: zod.string().describe("공급사 사용자 ID (users.id)"),
        isRevealed: zod
          .boolean()
          .describe("신원 공개 여부 (계약 체결·PRO 플랜·본인·어드민이면 true)"),
        companyName: zod
          .object({})
          .nullish()
          .describe("회사명 (익명이면 null)"),
        ceoName: zod.object({}).nullish().describe("대표자명 (익명이면 null)"),
        region: zod
          .object({})
          .nullish()
          .describe("지역 (시/도 + 시군구, 익명에도 공개)"),
        homepageUrl: zod.object({}).nullish().describe("홈페이지 URL"),
        logoUrl: zod.object({}).nullish().describe("회사 로고 URL"),
        landingThumbnailUrl: zod
          .object({})
          .nullish()
          .describe("홈페이지 랜딩 썸네일 URL (assets 사본)"),
        companyIntro: zod.object({}).nullish().describe("회사 소개"),
        productDescription: zod.object({}).nullish().describe("취급 품목 요약"),
        establishedAt: zod.object({}).nullish().describe("설립일"),
        yearsInBusiness: zod
          .object({})
          .nullish()
          .describe("업력 (년차, 설립일 미입력 시 null)"),
        joinedAt: zod.object({}).nullish().describe("세모 가입일"),
        trustScore: zod.object({}).nullish().describe("신뢰도 점수 (0-100)"),
        trustPercentile: zod
          .object({})
          .nullish()
          .describe("신뢰도 상위 백분위 (1=상위 1%)"),
        reviewSummary: zod
          .object({
            totalReviews: zod.number().describe("총 리뷰 수"),
            averageRating: zod.number().describe("평균 평점 (1-5)"),
            positiveReviewCount: zod
              .number()
              .describe("긍정 리뷰 수 (평점 4-5)"),
            negativeReviewCount: zod
              .number()
              .describe("부정 리뷰 수 (평점 1-2)"),
            topTags: zod
              .array(
                zod
                  .object({
                    label: zod.string().describe("태그 문구"),
                    count: zod.number().describe("태그 횟수"),
                  })
                  .strict(),
              )
              .describe("긍정 태그 상위"),
          })
          .strict()
          .describe("후기 요약"),
        certificationCount: zod.number().describe("검증된 인증서 수"),
        certifications: zod
          .array(
            zod
              .object({
                id: zod.string().describe("인증서 ID"),
                name: zod.string().describe("인증서 명칭"),
                issuer: zod.object({}).nullish().describe("발급 기관"),
                certNumber: zod.object({}).nullish().describe("인증 번호"),
                issuedAt: zod.object({}).nullish().describe("발급일"),
                expiresAt: zod.object({}).nullish().describe("만료일"),
                status: zod
                  .enum(["PENDING", "VERIFIED", "REJECTED"])
                  .describe("검증 상태"),
                source: zod
                  .enum(["SELF", "CMARKET"])
                  .describe(
                    "출처 — SELF: 세모에서 직접 업로드, CMARKET: 씨마켓 회원프로필 동기화(세모에서 수정·삭제 불가)",
                  ),
                kind: zod
                  .object({})
                  .nullish()
                  .describe(
                    "종류 (CERTIFICATION/LICENSE/CUSTOM, 씨마켓 동기화분만)",
                  ),
                rejectionReason: zod.object({}).nullish().describe("반려 사유"),
                fileUrl: zod
                  .object({})
                  .nullish()
                  .describe("업로드 파일 URL (본인/어드민만)"),
                fileName: zod.object({}).nullish().describe("업로드 파일명"),
                createdAt: zod.string().describe("등록일시"),
              })
              .strict(),
          )
          .describe("검증된 인증서 목록 (익명이면 빈 배열 — 개수만 공개)"),
        completeness: zod
          .object({
            percent: zod.number().describe("완성도 (0-100)"),
            missing: zod.array(zod.string()).describe("비어 있는 항목 키 목록"),
          })
          .strict()
          .describe("프로필 완성도"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 홈페이지·설립일·회사소개·취급품목을 수정한다. 홈페이지가 바뀌면 랜딩 썸네일을 다시 캡처한다.
 * @summary 내 기업 프로필 수정
 */
export const supplierProfileControllerUpdateMyProfileBody = zod
  .object({
    homepageUrl: zod
      .string()
      .optional()
      .describe("홈페이지 URL (변경 시 랜딩 썸네일 재캡처)"),
    establishedAt: zod.string().optional().describe("설립일"),
    companyIntro: zod.string().optional().describe("회사 소개"),
    productDescription: zod
      .string()
      .optional()
      .describe("취급 품목 요약 (255자)"),
  })
  .strict();

export const supplierProfileControllerUpdateMyProfileResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        supplierId: zod.string().describe("공급사 사용자 ID (users.id)"),
        isRevealed: zod
          .boolean()
          .describe("신원 공개 여부 (계약 체결·PRO 플랜·본인·어드민이면 true)"),
        companyName: zod
          .object({})
          .nullish()
          .describe("회사명 (익명이면 null)"),
        ceoName: zod.object({}).nullish().describe("대표자명 (익명이면 null)"),
        region: zod
          .object({})
          .nullish()
          .describe("지역 (시/도 + 시군구, 익명에도 공개)"),
        homepageUrl: zod.object({}).nullish().describe("홈페이지 URL"),
        logoUrl: zod.object({}).nullish().describe("회사 로고 URL"),
        landingThumbnailUrl: zod
          .object({})
          .nullish()
          .describe("홈페이지 랜딩 썸네일 URL (assets 사본)"),
        companyIntro: zod.object({}).nullish().describe("회사 소개"),
        productDescription: zod.object({}).nullish().describe("취급 품목 요약"),
        establishedAt: zod.object({}).nullish().describe("설립일"),
        yearsInBusiness: zod
          .object({})
          .nullish()
          .describe("업력 (년차, 설립일 미입력 시 null)"),
        joinedAt: zod.object({}).nullish().describe("세모 가입일"),
        trustScore: zod.object({}).nullish().describe("신뢰도 점수 (0-100)"),
        trustPercentile: zod
          .object({})
          .nullish()
          .describe("신뢰도 상위 백분위 (1=상위 1%)"),
        reviewSummary: zod
          .object({
            totalReviews: zod.number().describe("총 리뷰 수"),
            averageRating: zod.number().describe("평균 평점 (1-5)"),
            positiveReviewCount: zod
              .number()
              .describe("긍정 리뷰 수 (평점 4-5)"),
            negativeReviewCount: zod
              .number()
              .describe("부정 리뷰 수 (평점 1-2)"),
            topTags: zod
              .array(
                zod
                  .object({
                    label: zod.string().describe("태그 문구"),
                    count: zod.number().describe("태그 횟수"),
                  })
                  .strict(),
              )
              .describe("긍정 태그 상위"),
          })
          .strict()
          .describe("후기 요약"),
        certificationCount: zod.number().describe("검증된 인증서 수"),
        certifications: zod
          .array(
            zod
              .object({
                id: zod.string().describe("인증서 ID"),
                name: zod.string().describe("인증서 명칭"),
                issuer: zod.object({}).nullish().describe("발급 기관"),
                certNumber: zod.object({}).nullish().describe("인증 번호"),
                issuedAt: zod.object({}).nullish().describe("발급일"),
                expiresAt: zod.object({}).nullish().describe("만료일"),
                status: zod
                  .enum(["PENDING", "VERIFIED", "REJECTED"])
                  .describe("검증 상태"),
                source: zod
                  .enum(["SELF", "CMARKET"])
                  .describe(
                    "출처 — SELF: 세모에서 직접 업로드, CMARKET: 씨마켓 회원프로필 동기화(세모에서 수정·삭제 불가)",
                  ),
                kind: zod
                  .object({})
                  .nullish()
                  .describe(
                    "종류 (CERTIFICATION/LICENSE/CUSTOM, 씨마켓 동기화분만)",
                  ),
                rejectionReason: zod.object({}).nullish().describe("반려 사유"),
                fileUrl: zod
                  .object({})
                  .nullish()
                  .describe("업로드 파일 URL (본인/어드민만)"),
                fileName: zod.object({}).nullish().describe("업로드 파일명"),
                createdAt: zod.string().describe("등록일시"),
              })
              .strict(),
          )
          .describe("검증된 인증서 목록 (익명이면 빈 배열 — 개수만 공개)"),
        completeness: zod
          .object({
            percent: zod.number().describe("완성도 (0-100)"),
            missing: zod.array(zod.string()).describe("비어 있는 항목 키 목록"),
          })
          .strict()
          .describe("프로필 완성도"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 회사 로고 이미지를 업로드한다. 로고가 있으면 첫 글자 아바타 대신 로고가 그려진다.
 * @summary 회사 로고 업로드
 */
export const supplierProfileControllerUploadLogoBody = zod
  .object({
    file: zod
      .instanceof(File)
      .describe("로고 이미지 (JPEG, PNG, GIF, WebP — 최대 5MB)"),
  })
  .strict();

export const supplierProfileControllerUploadLogoResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        logoUrl: zod.string().describe("업로드된 로고 공개 URL"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 인증서(ISO·벤처·이노비즈 등)를 등록한다. 어드민 검증(VERIFIED) 후 프로필에 노출된다.
 * @summary 보유 인증서 등록
 */
export const supplierProfileControllerAddCertificationBody = zod
  .object({
    name: zod.string().describe("인증서 명칭"),
    issuer: zod.string().optional().describe("발급 기관"),
    certNumber: zod.string().optional().describe("인증 번호"),
    issuedAt: zod.string().optional().describe("발급일 (YYYY-MM-DD)"),
    expiresAt: zod.string().optional().describe("만료일 (YYYY-MM-DD)"),
    file: zod
      .instanceof(File)
      .optional()
      .describe("인증서 파일 (PDF 또는 이미지 — 최대 20MB)"),
  })
  .strict();

export const supplierProfileControllerAddCertificationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("인증서 ID"),
        name: zod.string().describe("인증서 명칭"),
        issuer: zod.object({}).nullish().describe("발급 기관"),
        certNumber: zod.object({}).nullish().describe("인증 번호"),
        issuedAt: zod.object({}).nullish().describe("발급일"),
        expiresAt: zod.object({}).nullish().describe("만료일"),
        status: zod
          .enum(["PENDING", "VERIFIED", "REJECTED"])
          .describe("검증 상태"),
        source: zod
          .enum(["SELF", "CMARKET"])
          .describe(
            "출처 — SELF: 세모에서 직접 업로드, CMARKET: 씨마켓 회원프로필 동기화(세모에서 수정·삭제 불가)",
          ),
        kind: zod
          .object({})
          .nullish()
          .describe("종류 (CERTIFICATION/LICENSE/CUSTOM, 씨마켓 동기화분만)"),
        rejectionReason: zod.object({}).nullish().describe("반려 사유"),
        fileUrl: zod
          .object({})
          .nullish()
          .describe("업로드 파일 URL (본인/어드민만)"),
        fileName: zod.object({}).nullish().describe("업로드 파일명"),
        createdAt: zod.string().describe("등록일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 보유 인증서 삭제
 */
export const supplierProfileControllerDeleteCertificationParams = zod
  .object({
    certificationId: zod.coerce.string().describe("인증서 ID"),
  })
  .strict();

export const supplierProfileControllerDeleteCertificationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 구매자가 보는 공급사 프로필. 계약 전 익명 단계에서는 신원(회사명·로고·홈페이지)은 가려지고 신뢰 지표(신뢰도·후기·업력·인증 개수)만 내려간다.
 * @summary 공급사 기업 프로필 조회
 */
export const supplierProfileControllerGetPublicProfileParams = zod
  .object({
    supplierId: zod.coerce.string().describe("공급사 사용자 ID (users.id)"),
  })
  .strict();

export const supplierProfileControllerGetPublicProfileQueryParams = zod
  .object({
    chatRoomId: zod.coerce
      .string()
      .optional()
      .describe("채팅방 문맥 — 있으면 그 방의 계약 여부로 공개를 판정"),
  })
  .strict();

export const supplierProfileControllerGetPublicProfileResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        supplierId: zod.string().describe("공급사 사용자 ID (users.id)"),
        isRevealed: zod
          .boolean()
          .describe("신원 공개 여부 (계약 체결·PRO 플랜·본인·어드민이면 true)"),
        companyName: zod
          .object({})
          .nullish()
          .describe("회사명 (익명이면 null)"),
        ceoName: zod.object({}).nullish().describe("대표자명 (익명이면 null)"),
        region: zod
          .object({})
          .nullish()
          .describe("지역 (시/도 + 시군구, 익명에도 공개)"),
        homepageUrl: zod.object({}).nullish().describe("홈페이지 URL"),
        logoUrl: zod.object({}).nullish().describe("회사 로고 URL"),
        landingThumbnailUrl: zod
          .object({})
          .nullish()
          .describe("홈페이지 랜딩 썸네일 URL (assets 사본)"),
        companyIntro: zod.object({}).nullish().describe("회사 소개"),
        productDescription: zod.object({}).nullish().describe("취급 품목 요약"),
        establishedAt: zod.object({}).nullish().describe("설립일"),
        yearsInBusiness: zod
          .object({})
          .nullish()
          .describe("업력 (년차, 설립일 미입력 시 null)"),
        joinedAt: zod.object({}).nullish().describe("세모 가입일"),
        trustScore: zod.object({}).nullish().describe("신뢰도 점수 (0-100)"),
        trustPercentile: zod
          .object({})
          .nullish()
          .describe("신뢰도 상위 백분위 (1=상위 1%)"),
        reviewSummary: zod
          .object({
            totalReviews: zod.number().describe("총 리뷰 수"),
            averageRating: zod.number().describe("평균 평점 (1-5)"),
            positiveReviewCount: zod
              .number()
              .describe("긍정 리뷰 수 (평점 4-5)"),
            negativeReviewCount: zod
              .number()
              .describe("부정 리뷰 수 (평점 1-2)"),
            topTags: zod
              .array(
                zod
                  .object({
                    label: zod.string().describe("태그 문구"),
                    count: zod.number().describe("태그 횟수"),
                  })
                  .strict(),
              )
              .describe("긍정 태그 상위"),
          })
          .strict()
          .describe("후기 요약"),
        certificationCount: zod.number().describe("검증된 인증서 수"),
        certifications: zod
          .array(
            zod
              .object({
                id: zod.string().describe("인증서 ID"),
                name: zod.string().describe("인증서 명칭"),
                issuer: zod.object({}).nullish().describe("발급 기관"),
                certNumber: zod.object({}).nullish().describe("인증 번호"),
                issuedAt: zod.object({}).nullish().describe("발급일"),
                expiresAt: zod.object({}).nullish().describe("만료일"),
                status: zod
                  .enum(["PENDING", "VERIFIED", "REJECTED"])
                  .describe("검증 상태"),
                source: zod
                  .enum(["SELF", "CMARKET"])
                  .describe(
                    "출처 — SELF: 세모에서 직접 업로드, CMARKET: 씨마켓 회원프로필 동기화(세모에서 수정·삭제 불가)",
                  ),
                kind: zod
                  .object({})
                  .nullish()
                  .describe(
                    "종류 (CERTIFICATION/LICENSE/CUSTOM, 씨마켓 동기화분만)",
                  ),
                rejectionReason: zod.object({}).nullish().describe("반려 사유"),
                fileUrl: zod
                  .object({})
                  .nullish()
                  .describe("업로드 파일 URL (본인/어드민만)"),
                fileName: zod.object({}).nullish().describe("업로드 파일명"),
                createdAt: zod.string().describe("등록일시"),
              })
              .strict(),
          )
          .describe("검증된 인증서 목록 (익명이면 빈 배열 — 개수만 공개)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
